import { SimpleSpine } from '@/containers/common/SimpleSpine'
import { ReelsContainerHelper } from '@/containers/reels/ReelsContainerHelper'
import { IStoppingReelsData } from '@/modules'
import GameSignals from '@/signals/GameSignals'
import * as PIXI from 'pixi.js'
import gsap from 'gsap'
import Facade from '@/Facade'
import { ContainersNames } from '@/containers/ContainersNames'

export class AnticipationContainer extends PIXI.Container {
    private readonly _suspenseFrame: SimpleSpine | null
    private readonly _frameWrapper: PIXI.Container
    private _anticipationIndices: number[]
    private _isActive: number[]
    private _isReelsStopped: boolean

    public constructor() {
        super()
        GameSignals.stoppingReels.connect(this.onStoppingReels)
        GameSignals.reelStopped.connect(this.onSpinReelStopped)
        GameSignals.stopButtonClicked.connect(this.onImmediateStopReels)

        try {
            this._suspenseFrame = new SimpleSpine('suspenseFrame')
            this._suspenseFrame.position.set(
                Facade.symbolsConfig.WIDTH / 2,
                ReelsContainerHelper.calculateContainerHeight() / 2
            )
            this._suspenseFrame.scale.set(0.85)
        } catch (error) {
            // Asset suspenseFrame non disponibile: anticipation senza animazione spine.
            this._suspenseFrame = null
        }

        this._frameWrapper = new PIXI.Container()
        this._frameWrapper.name = ContainersNames.ANIMATION_WRAPPER
        if (this._suspenseFrame) {
            this._frameWrapper.addChild(this._suspenseFrame)
        }
        this.addChild(this._frameWrapper)

        this.visible = false
        this.alpha = 0
        this._anticipationIndices = null
        this._isActive = []
    }

    private onImmediateStopReels = () => {
        this._isReelsStopped = true
    }

    private onStoppingReels = (data: IStoppingReelsData) => {
        this._anticipationIndices = data.anticipationIndices
        this._isReelsStopped = false
    }

    private onSpinReelStopped = (reelIdx: number) => {
        const nextReelIdx: number = reelIdx + 1
        const canShow: boolean =
            this._anticipationIndices &&
            this._anticipationIndices.includes(nextReelIdx) &&
            !this._isReelsStopped &&
            !this._isActive.includes(nextReelIdx)

        if (canShow) {
            this.showFrame(nextReelIdx)
            return
        }

        if (this._isActive.length) {
            this.hideFrame()
        }
    }

    private showFrame(reelIdx: number) {
        this._frameWrapper.position.x = ReelsContainerHelper.calculateReelWidth() * reelIdx
        if (this._suspenseFrame) {
            this._suspenseFrame.play('animation', true)
        }
        this.visible = true
        GameSignals.showSuspenseAnimation.emit()

        if (!this._isActive.length) {
            gsap.to(this, { duration: 0.3, alpha: 1 })
        }

        this._isActive = [reelIdx]
    }

    private hideFrame() {
        this._isActive = []

        gsap.to(this, {
            duration: 0.5,
            alpha: 0,
            onComplete: () => {
                if (this._suspenseFrame) {
                    this._suspenseFrame.stop()
                }
                this.visible = false
                GameSignals.hideSuspenseAnimation.emit()
            },
        })
    }
}
